/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_UnpaidInputs */

const zh_status_unpaid = /** @type {(inputs: Status_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未支付`)
};

const en_status_unpaid = /** @type {(inputs: Status_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpaid`)
};

const es_status_unpaid = /** @type {(inputs: Status_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impago`)
};

/**
* | output |
* | --- |
* | "Unpaid" |
*
* @param {Status_UnpaidInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_unpaid = /** @type {((inputs?: Status_UnpaidInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_UnpaidInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_status_unpaid(inputs)
	if (locale === "en") return en_status_unpaid(inputs)
	return es_status_unpaid(inputs)
});